import parse from 'utils/parse';
import type { ResponsiveImageOutput } from 'contracts';

import messages from './success-stories-banner.i18n';
import Vicky from './assets/Vicky.jpg';
import Rebecca from './assets/Rebecca.jpg';
import CharlotteMavis from './assets/CharlotteMavis.jpg';
import Amanda from './assets/Amanda.jpg';
import LanaRhodes from './assets/LanaRhodes.jpg';
import EvaTalks from './assets/EvaTalks.jpg';
import NicoleBella from './assets/NicoleBella.jpg';

const { quotes } = messages.pages.landing.successStoriesBanner.livejasmin;
const makeTestId = (...ids: string[]): string => parse.toTestId('landing', 'success-stories-banner', ...ids);

const testId = Object.freeze({
  component: makeTestId(),
  joinNowButton: makeTestId('join-now-button'),
});

const config = {
  models: [
    {
      image: Vicky as ResponsiveImageOutput,
      name: 'Vicky',
      quote: quotes.vicky,
      link: 'https://lifeinred.com/10-years-in-cam-industry-insights-success-keys-empowerment-vickys-journey/',
    },
    {
      image: Rebecca as ResponsiveImageOutput,
      name: 'Rebecca',
      quote: quotes.rebecca,
      link: 'https://lifeinred.com/rebecca-interview/',
    },
    {
      image: CharlotteMavis as ResponsiveImageOutput,
      name: 'CharlotteMavis',
      quote: quotes.charlotteMavis,
      link: 'https://lifeinred.com/charlottemavis-journey-to-top-earner-embrace-authenticity/',
    },
    {
      image: Amanda as ResponsiveImageOutput,
      name: 'Amanda',
      quote: quotes.amandaRuth,
      link: 'https://lifeinred.com/amandaruth-unveiling-the-truth-secrets-to-success-in-the-modeling-world-revealed/',
    },
    {
      image: LanaRhodes as ResponsiveImageOutput,
      name: 'LanaRhodes',
      quote: quotes.lanaRhodes,
      link: 'https://lifeinred.com/authentic-connections-lana-rhodes-journey-on-jasmin-and-soldier-aid-campaign/',
    },
    {
      image: EvaTalks as ResponsiveImageOutput,
      name: 'EvaTalks',
      quote: quotes.evaTalks,
      link: 'https://lifeinred.com/eva-talks-interview/',
    },
    {
      image: NicoleBella as ResponsiveImageOutput,
      name: 'NicoleBella',
      quote: quotes.nicoleBella,
      link: 'https://lifeinred.com/9-years-on-livejasmin-freedom-success-acting-dreams/',
    },
  ],
};

export { testId, config };
